import { useEffect, useState } from 'react';

import { useFormikContext } from 'formik';

import { getHours, getMinutesForSelect } from '@/helpers';
import { setDate } from '@/helpers/date';

type CustomTimeInputProps = {
  id: string;
  date: Date;
};

export const CustomTimeInput = ({ id, date }: CustomTimeInputProps) => {
  const pad = (num: number) => num.toString().padStart(2, '0');
  const [hours, setHours] = useState<string>(pad(date.getHours()));
  const [minutes, setMinutes] = useState<string>(pad(date.getMinutes()));
  const { setFieldValue } = useFormikContext();

  const handleChangeHours = (hoursValue: string) => {
    setHours(hoursValue as string);
  };

  const handleChangeMinutes = (minutesValue: string) => {
    setMinutes(minutesValue as string);
  };

  useEffect(() => {
    setFieldValue(id, setDate(date as Date, Number(hours), Number(minutes)));
  }, [hours, minutes]);

  return (
    <div className='flex size-full justify-between'>
      <div className='flex w-1/2 justify-between'>
        <select
          onChange={(e) => handleChangeHours(e.target.value)}
          className='mr-2 h-7 rounded-md bg-secondary-pale-blue-gray px-2.5 py-0.5'>
          {getHours().map((hour) => (
            <option
              key={hour}
              value={hour}
              selected={Number(minutes) > 55 ? Number(hour) === Number(hours) + 1 : hour === hours}>
              {hour}
            </option>
          ))}
        </select>
        <select
          onChange={(e) => handleChangeMinutes(e.target.value)}
          className='h-7 rounded-md bg-secondary-pale-blue-gray px-2.5 py-0.5'>
          {getMinutesForSelect().map((minute) => (
            <option
              key={minute}
              value={minute}
              selected={
                Number(minutes) > 55
                  ? minute === '00'
                  : Number(minute) - Number(minutes) < 5 && Number(minute) - Number(minutes) >= 0
              }>
              {minute}
            </option>
          ))}
        </select>
      </div>
    </div>
  );
};
